import { render } from "./Portal.vue?vue&type=template&id=367f107a"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__